angular.
module("dx.webapp.jobs").
constant("DX_JOB_TYPE", Object.freeze({
	IMPORT_TEACHER_DATA: "import_teacher_data",
	IMPORT_STUDENT_DATA: "import_student_data",
	GDPR_DELETE_USER: "gdpr_delete_user",
	GDPR_DELETE_STUDENT: "gdpr_delete_student",
	EXPORT_ORGANIZATION_DATA: "export_organization_data",
}));
